var React = require('react');

function ScalableLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 46a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 46c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm0 2c9.389 0 17-7.611 17-17s-7.611-17-17-17S7 21.611 7 31s7.611 17 17 17z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22zm0 2c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z","key":2})]);
}

ScalableLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ScalableLight;

ScalableLight.default = ScalableLight;
